import React from 'react';
import { Loader2, AlertCircle, Inbox } from 'lucide-react';

export const LoadingState: React.FC<{ message?: string }> = ({ message = 'Carregando...' }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-8)', color: 'var(--color-text-secondary)' }}>
    <Loader2 className="animate-spin" size={32} style={{ marginBottom: 'var(--space-4)', color: 'var(--color-primary-500)', animation: 'spin 1s linear infinite' }} />
    <p>{message}</p>
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

export const EmptyState: React.FC<{ title: string; description: string; action?: React.ReactNode }> = ({ title, description, action }) => (
  <div className="glass hover-card animate-fade-in-up" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-12) var(--space-4)', textAlign: 'center', borderRadius: 'var(--radius-lg)' }}>
    <div style={{ background: 'var(--color-bg-elevated)', padding: 'var(--space-4)', borderRadius: 'var(--radius-full)', marginBottom: 'var(--space-4)' }}>
      <Inbox size={40} color="var(--color-text-muted)" />
    </div>
    <h3 style={{ fontSize: 'var(--text-lg)', fontWeight: 'var(--font-medium)', marginBottom: 'var(--space-2)' }}>{title}</h3>
    <p style={{ color: 'var(--color-text-secondary)', marginBottom: 'var(--space-6)', maxWidth: '400px' }}>{description}</p>
    {action && <div>{action}</div>}
  </div>
);

export const ErrorState: React.FC<{ message: string; onRetry?: () => void }> = ({ message, onRetry }) => (
  <div className="glass animate-fade-in" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-8)', color: 'var(--color-error)', border: '1px solid rgba(239, 68, 68, 0.2)', borderRadius: 'var(--radius-lg)' }}>
    <AlertCircle size={32} style={{ marginBottom: 'var(--space-2)' }} />
    <p style={{ marginBottom: onRetry ? 'var(--space-4)' : 0 }}>{message}</p>
    {onRetry && (
      <button onClick={onRetry} style={{ padding: 'var(--space-2) var(--space-4)', background: 'rgba(239, 68, 68, 0.1)', color: 'var(--color-error)', border: 'none', cursor: 'pointer', borderRadius: 'var(--radius-md)', fontWeight: 'var(--font-medium)' }} className="btn">
        Tentar Novamente
      </button>
    )}
  </div>
);
